import { inject } from '@angular/core';
import { getSelfRegistration } from '@app/app.reducer';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { BookingPackageType } from '@products/models/booking.model';
import { PackageProductBookingActions } from '@store/products/booking/product/package/package-booking.actions';
import { VoucherProductBookingActions } from '@store/products/booking/product/voucher/voucher-booking.actions';
import { ProductSelectionActions } from '@store/products/product-selection/product-selection.actions';
import { VoucherProductActions } from '@store/products/product.actions';
import { map } from 'rxjs';

export const addVoucher$ = createEffect(
  (actions$ = inject(Actions), store = inject(Store)) =>
    actions$.pipe(
      ofType(
        VoucherProductBookingActions.setVoucherProductInBookingList,
        VoucherProductBookingActions.setVoucherForAnonymousProductInBookingList
      ),
      concatLatestFrom(() => store.select(getSelfRegistration)),
      map(([{ bookingProductTypes }, isSelfRegistration]) =>
        ProductSelectionActions.setVoucherProductInSelectionList({ bookingProductTypes, isSelfRegistration })
      )
    ),
  { functional: true }
);

export const removeVoucherByVoucherCode$ = createEffect(
  (actions$ = inject(Actions)) =>
    actions$.pipe(
      ofType(VoucherProductActions.removeReleasedAndRemovedProductBookingVoucherFromProductSelection),
      map(({ voucherCode }) => ProductSelectionActions.removeVoucherCodeProductFromSelectionList(voucherCode))
    ),
  { functional: true }
);

export const removeVoucher$ = createEffect(
  (actions$ = inject(Actions)) =>
    actions$.pipe(
      ofType(VoucherProductBookingActions.removeReleasedVoucherProductFromBookingList),
      map(({ bookingProductTypes }) =>
        ProductSelectionActions.removeVoucherProductFromSelectionList(bookingProductTypes)
      )
    ),
  { functional: true }
);

export const addPackage$ = createEffect(
  (actions$ = inject(Actions)) =>
    actions$.pipe(
      ofType(PackageProductBookingActions.setPackageProductInBookingList),
      map(({ bookingProductTypes }) =>
        ProductSelectionActions.setPackageInSelectionList(bookingProductTypes as BookingPackageType[])
      )
    ),
  { functional: true }
);

export const removePackage$ = createEffect(
  (actions$ = inject(Actions)) =>
    actions$.pipe(
      ofType(PackageProductBookingActions.removePackageFromBookingList),
      map(({ bookingProductTypes }) =>
        ProductSelectionActions.removePackageFromSelectionList(bookingProductTypes as BookingPackageType[])
      )
    ),
  { functional: true }
);
